import * as ACTION_TYPES from "./actionTypes";
import { secure } from "./API/faiz";
import { FAIZ_ACCESS_TOKEN } from "../constants/staticKeys";
import { errorMessageHandle } from "../constants/utilities";
import { toast } from "react-toastify";

const {
  UPDATE_VENUE_PROPS,
  DELETE_VENUE_PROPS,
  MERGE_VENUE_PROPS
} = ACTION_TYPES;
export const updateVenueProp = (prop, value) => {
  return { type: UPDATE_VENUE_PROPS, payload: [{ prop, value }] };
};
export const updateVenueProps = (payload) => {
  return { type: UPDATE_VENUE_PROPS, payload: payload };
};
export const mergeVenueProps = (payload) => {
  return { type: MERGE_VENUE_PROPS, payload: payload };
};
export const deleteVenueProp = (prop) => {
  return { type: DELETE_VENUE_PROPS, payload: [{ prop }] };
};
export const deleteVenueProps = (payload) => {
  return { type: DELETE_VENUE_PROPS, payload };
};

export const getVenues = (prop, page, param) => async (dispatch, getState) => {
  let url = "/venue?page=" + page;
  let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
  dispatch({
    type: UPDATE_VENUE_PROPS,
    payload: [{ prop: "isVenueLoading", value: true }],
  });
  secure(token)
    .get(url, { params: param })
    .then((response) => {
      let total = 0;
      for (let i = 0; i < response.data.venues.data.length; i++) {
        total = total + parseFloat(response.data.venues.data[i].score);
      }
      dispatch({
        type: UPDATE_VENUE_PROPS,
        payload: [
          { prop, value: response.data.venues },
          { prop: "totalScore", value: total },
          { prop: "selectedVenueIds", value: [] },
        ],
      });
    })
    .catch((error) => {
      dispatch({ type: UPDATE_VENUE_PROPS, payload: [{ prop, value: [] }] });
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    })
    .finally((f) => {
      dispatch({
        type: UPDATE_VENUE_PROPS,
        payload: [{ prop: "isVenueLoading", value: false }],
      });
    });
};
const validateVenues = (venues) => {
  let isValid = true;
  for (let i = 0; i < venues.length; i++) {
    let message = "";
    if (venues[i].name === "") {
      message = message + "Venue name is mandatory. ";
      isValid = false;
    }
    if (parseFloat(venues[i].score) <= 0 || venues[i].score === "") {
      message = message + "Venue score must be greater than 0. ";
      isValid = false;
    }

    if (message !== "") {
      message = message + "Check row " + (i + 1);
      toast.error(message);
    }
  }
  return isValid;
};
export const saveVenues = (venues) => async (dispatch, getState) => {
  let editedVenues = venues.data.filter((v) => {
    return v.edited === true;
  });
  if (editedVenues.length === 0) {
  } else if (validateVenues(editedVenues)) {
    let url = "/venue";
    let param = { venues: editedVenues };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_VENUE_PROPS,
      payload: [{ prop: "isVenueSaving", value: true }],
    });
    secure(token)
      .post(url, param)
      .then((response) => {
        dispatch({
          type: UPDATE_VENUE_PROPS,
          payload: [{ prop: "isVenuesTableEditable", value: false }],
        });
        for (let i = 0; i < venues.length; i++) {
          dispatch({
            type: DELETE_VENUE_PROPS,
            payload: [{ prop: "venues.data." + i + ".edited" }],
          });
        }
        toast.success(response.data.msg);
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_VENUE_PROPS,
          payload: [{ prop: "isVenueSaving", value: false }],
        });
      });
  } else {
    dispatch({ type: "" });
  }
};

export const deleteVenues = (venues) => async (dispatch, getState) => {
  const persistedVenues = venues.filter((venue) => venue && venue.hasOwnProperty("id"));
  const transientIndexes = venues
    .filter((venue) => !venue || !venue.hasOwnProperty("id"))
    .map((venue) => venue.index)
    .filter((index) => index != null);
  const persistedIndexes = persistedVenues
    .map((venue) => venue.index)
    .filter((index) => index != null);

  if (persistedVenues.length > 0) {
    let url = "/venue";
    let param = { venues: persistedVenues.map((venue) => venue.id) };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_VENUE_PROPS,
      payload: persistedIndexes.map((index) => ({
        prop: "venues.data." + index + ".isDeleting",
        value: true,
      })),
    });
    secure(token)
      .delete(url, { data: param })
      .then((response) => {
        const { venuesReducer } = getState();
        const currentRows = venuesReducer.venues && venuesReducer.venues.data ? venuesReducer.venues.data : [];
        const deletedIds = persistedVenues.map((venue) => String(venue.id));
        const remainingRows = currentRows.filter((venue) => !deletedIds.includes(String(venue.id)));
        const totalScore = remainingRows.reduce((sum, venue) => sum + parseFloat(venue.score || 0), 0);
        dispatch({
          type: UPDATE_VENUE_PROPS,
          payload: [
            { prop: "venues.data", value: remainingRows },
            { prop: "totalScore", value: totalScore },
            { prop: "selectedVenueIds", value: [] },
          ],
        });
        toast.success(response.data.msg);
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_VENUE_PROPS,
          payload: persistedIndexes.map((index) => ({
            prop: "venues.data." + index + ".isDeleting",
            value: false,
          })),
        });
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      });
  } else {
    transientIndexes
      .sort((a, b) => b - a)
      .forEach((index) => {
        dispatch({
          type: DELETE_VENUE_PROPS,
          payload: [{ prop: "venues.data." + index }],
        });
      });
    dispatch({
      type: UPDATE_VENUE_PROPS,
      payload: [{ prop: "selectedVenueIds", value: [] }],
    });
  }
};

export const createVenues = (venues) => async (dispatch, getState) => {
  if (venues.length === 0) {
    toast.error("No venues to create");
  } else if (validateVenues(venues)) {
    let url = "/venue";
    let param = { venues: venues };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_VENUE_PROPS,
      payload: [{ prop: "isVenueCreating", value: true }],
    });
    secure(token)
      .post(url, param)
      .then((response) => {
        dispatch({
          type: UPDATE_VENUE_PROPS,
          payload: [
            { prop: "isNewVenueModalOpen", value: false },
            { prop: "newVenues", value: [] },
          ],
        });
        dispatch({
          type: MERGE_VENUE_PROPS,
          payload: [{ prop: "venues.data", value: response.data.venues }],
        });
        toast.success(response.data.msg);
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_VENUE_PROPS,
          payload: [{ prop: "isVenueCreating", value: false }],
        });
      });
  } else {
    dispatch({ type: "" });
  }
};
